module.exports = __webpack_public_path__ + "assets/img/icon-search-gray.3412440d.png";